<template>
  <a-spin :spinning="spinning" tip="正在加载...">
    <div class="info">
      <div class="pt-6 step-form-form">
        <a-steps :current="current">
          <a-step title="选择解密方式" />
          <a-step title="填写信息" />
          <a-step title="完成" />
        </a-steps>
      </div>
      <div class="mt-6">
        <div v-show="current === 0">
          <Step0 @next="handleStep0Next" :bidderInfo="bidderInfo" :toubaono="bidderInfo.toubaono" />
        </div>
        <div v-show="current === 1">
          <Step1 @next="handleStepNext" :bidderInfo="bidderInfo" :reopen="reopen" :caMethod="caMethod" />
        </div>
        <div v-show="current === 2">
          <Step2 @next="handleStepNext" />
        </div>
      </div>
    </div>
  </a-spin>
</template>
<script>
  import { contract_ca_by_uuid } from '@/api/contract';
  import Step0 from './step/step0.vue';
  import Step1 from './step/step1.vue';
  import Step2 from './step/step2.vue';
  export default {
    components: {
      Step0,
      Step1,
      Step2,
    },
    data() {
      return {
        current: 0,
        reopen: 0,
        activated: false,
        spinning: true,
        bidderInfo: {},
        caMethod: null, // 存储用户选择的CA解密方式
      };
    },
    mounted() {
      this.getInfo();
    },
    activated() {
      this.activated = !this.activated;
      this.current = 0;
      this.reopen++;
    },
    methods: {
      async getInfo() {
        this.spinning = true;
        this.bidderInfo = await contract_ca_by_uuid(this.$route.query.id, this.$route.query.uuid);
        if (this.bidderInfo.is_confirm) {
          await this.$store.dispatch('user/loginggb', {
            id: this.$route.query.id,
            uuid: this.$route.query.uuid,
            type: 4,
            mode: 'none', //不要默认的错误提示
            ggb: 'anqing',
          });
          if (this.$route.query.type == '2') {
            this.$router.push(`/admin/contract_detail/${this.bidderInfo.id}?tab=2`);
          } else if (this.$route.query.type == '4') {
            this.$router.push(`/admin/contract_detail/${this.bidderInfo.id}?tab=4`);
          } else {
            this.$router.push(`/admin/contract_detail/${this.bidderInfo.id}`);
          }
          this.spinning = false;
          return;
        }
        if (this.bidderInfo.ca_decrypt_status) {
          await this.$store.dispatch('user/loginggb', {
            id: this.$route.query.id,
            uuid: this.$route.query.uuid,
            type: 4,
            mode: 'none', //不要默认的错误提示
            ggb: 'anqing',
          });
          this.current = 1;
        }
        this.spinning = false;
      },
      async refreshBidderInfo() {
        this.spinning = true;
        await this.$store.dispatch('user/loginggb', {
          id: this.$route.query.id,
          uuid: this.$route.query.uuid,
          type: 4,
          mode: 'none', //不要默认的错误提示
          ggb: 'anqing',
        });
        this.bidderInfo = await contract_ca_by_uuid(
          this.$route.query.id,
          this.$route.query.uuid
        );
        this.spinning = false;
      },
      async handleStep0Next(data) {
        // 保存用户选择的CA解密方式
        this.caMethod = data.caMethod;
        await this.refreshBidderInfo();
        this.current++;
      },
      handleStepNext() {
        this.activated = false;
        this.current++;
      },
    },
  };
</script>
<style scoped>
  .info {
    background: #ffffff;
    min-height: calc(100vh - 135px)
  }
  .step-form-form {
    width: 960px;
    margin: 0 auto 0 auto;
  }
</style>
